import { RouteObject, Navigate, useParams } from "react-router";
import WidgetLayout from "src/layouts/WidgetLayout/WidgetLayout";
import HomePage from "src/content/pages/HomePage";
import GetStartedPage from "./content/pages/GetStartedPage";
import TermsAndConditionsPage from "./content/pages/TermsAndConditionsPage";
import TermsAndConditions from "./components/TermsAndConditions/TermsAndConditions";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import LoginFormYahoo from "./components/LoginForm/LoginFormYahoo";
import AuthCallback from "./components/AuthCallback/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import StripeReturn from "./components/StripeReturn/StripeReturn";
import ArticlesPage from "./pages/ArticlesPage";
import FaqPage from "./pages/FaqPage";
import GlossaryPage from "./pages/GlossaryPage";
import ContactUs from "./content/pages/ContactUs";

/** Accidental SEO path from Auth0 /home base — send crawlers to the real public page. */
function RedirectHomeArticleSlug() {
  const { slug } = useParams<{ slug: string }>();
  return <Navigate to={slug ? `/articles/${slug}` : "/articles"} replace />;
}

const routes: RouteObject[] = [
  {
    path: "/",
    element: <WidgetLayout />,
    children: [
      {
        path: "/",
        // Non-logged experience (no Auth0, no ProtectedRoute). Former /home-free.
        element: <HomePage isLoggedInAuth0Experience={false} />,
      },
      {
        path: "/get-started",
        // GetStartedPage: Only used when user logs out
        element: <GetStartedPage />,
      },
      {
        path: "/home",
        // Logged-in experience with Auth0
        element: (
          <ProtectedRoute>
            <HomePage isLoggedInAuth0Experience={true} />
          </ProtectedRoute>
        ),
      },
      {
        path: "/home-free",
        // Legacy alias: former non-logged path → /
        element: <Navigate to="/" replace />,
      },
      {
        path: "/articles",
        // Public articles page with the same list/detail content from the homepage drawer
        element: <ArticlesPage />,
      },
      {
        path: "/articles/:slug",
        // Clean URL for article deep links (SEO-friendly; legacy ?id= still supported via redirect)
        element: <ArticlesPage />,
      },
      {
        path: "/faq",
        element: <FaqPage />,
      },
      {
        path: "/glossary",
        element: <GlossaryPage />,
      },
      {
        path: "/home/articles",
        element: <Navigate to="/articles" replace />,
      },
      {
        path: "/home/articles/:slug",
        element: <RedirectHomeArticleSlug />,
      },
      {
        path: "/home/faq",
        element: <Navigate to="/faq" replace />,
      },
      {
        path: "/home/glossary",
        element: <Navigate to="/glossary" replace />,
      },
      {
        path: "/home/:yahoo_token",
        element: (
          <ProtectedRoute>
            <HomePage isLoggedInAuth0Experience={true} />
          </ProtectedRoute>
        ),
      },
      {
        path: "/yahoo_callback",
        element: <AuthCallback />,
      },
      {
        path: "/stripe-return",
        element: <StripeReturn />,
      },
      {
        path: "/terms-and-conditions",
        element: <TermsAndConditionsPage />,
      },
      {
        path: "/terms-conditions",
        element: <TermsAndConditions />,
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "/contact",
        element: <ContactUs />,
      },
    ],
  },
  {
    // Unknown paths (legacy /contact-us, typos) land on /.
    // App.tsx sends authenticated users from / to /home.
    path: "*",
    element: <Navigate to="/" replace />,
  },
];

export default routes;
